import type { IColumnFormatConfig } from './_type';
import { resolveConfigFunction } from '@/pages/dashboard/components/CommonTable/utils/resolveConfigFunction';

/**
 * 解析下载列的条件覆盖，与宽表 resolveColumns 语义一致。
 * 覆盖列通过 overrideCode 声明要覆盖哪个 base 列，overrideWhen 返回 true 时生效。
 */
export function resolveDownloadColumns(
  columns: IColumnFormatConfig[],
  context: Record<string, unknown> | undefined,
): IColumnFormatConfig[] {
  const baseColumns = columns.filter((col) => !col.overrideCode);
  const overrideColumns = columns.filter((col) => col.overrideCode);

  if (!overrideColumns.length) {
    return baseColumns;
  }

  return baseColumns.map((col) => {
    const matched = overrideColumns.find((override) => {
      const overrideWhen = resolveConfigFunction(override.overrideWhen);
      return override.overrideCode === col.code && overrideWhen?.(context);
    });
    if (!matched) {
      return col;
    }
    const overrideProps: Partial<IColumnFormatConfig> = Object.assign({}, matched);
    delete overrideProps.overrideWhen;
    delete overrideProps.overrideCode;
    return Object.assign({}, col, overrideProps);
  });
}
